module.exports = __webpack_public_path__ + "static/media/Provider.f90805db.png";